export default __webpack_public_path__ + "media/design-system/close-button/assets/close-c092c5cd4895fa12c6f989c915fd1d43.svg";